// extracted by mini-css-extract-plugin
module.exports = {"card":"M2Jn5F1tFnhn_tZKz3Pbe","link":"_3AL9jbcqx5hBGp-RJRVDcj","skillImage":"_3acD7NpgM_x3pienXZtxa9","imageWrapper":"_3e6wNIYYe2xB_qTEtcotWH"};